module.exports = __webpack_public_path__ + "img/hz_6.bf6555f2.jpg";